import { useState } from 'react';
import { NgayThanhToan } from '@/types/schemas';

/**
 * Custom hook for managing payment day state
 */
export const usePaymentDay = (initialPaymentDay: string | null = null) => {
  const [selectedPaymentDay, setSelectedPaymentDay] = useState<NgayThanhToan | null>(
    initialPaymentDay ? { ma: initialPaymentDay, ten: `Ngày ${initialPaymentDay}` } : null
  );

  const handleSetSelectedPaymentDay = (paymentDay: NgayThanhToan) => {
    setSelectedPaymentDay(paymentDay);
  };

  return {
    selectedPaymentDay,
    setSelectedPaymentDay: handleSetSelectedPaymentDay
  };
};
